import { render } from "./SlotDetails.vue?vue&type=template&id=5c02aa1e&scoped=true&ts=true"
import script from "./SlotDetails.vue?vue&type=script&lang=ts"
export * from "./SlotDetails.vue?vue&type=script&lang=ts"

import "./SlotDetails.vue?vue&type=style&index=0&id=5c02aa1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c02aa1e"]])

export default __exports__